import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

// „Fortbildung vor Ort“: geplant, noch ohne Inhalte (Frage 292, Daniel 14.10.2026). Bis dahin ein Satz mit dem Weg
// zum Kontakt statt „Inhalt bald verfügbar“, und noindex, bis die Seite Inhalte hat.
const InhouseSchulungen = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Fortbildung vor Ort – MusiKonzept</title>
        <meta name="description" content="Musikpädagogische Fortbildungen für Kitas, Träger und Bildungseinrichtungen bei euch vor Ort." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <Header />
      <main className="pt-32 pb-20">
        <div className="container mx-auto px-6">
          <div className="max-w-2xl mx-auto text-center space-y-6">
            <h1 className="text-4xl md:text-5xl font-bold">Fortbildung vor Ort</h1>
            <p className="text-lg text-muted-foreground leading-relaxed">
              Ihr wünscht euch eine Fortbildung für euer ganzes Team in eurer Einrichtung? Schreibt uns, was ihr vorhabt,
              dann melden wir uns mit einem Vorschlag.
            </p>
            <Link
              to="/kontakt"
              className="inline-flex min-h-[44px] items-center justify-center rounded-full bg-[#227277] px-6 text-sm font-bold text-white hover:bg-[#1D2934]"
            >
              Kontakt aufnehmen
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default InhouseSchulungen;
